<div class="loading-overlay" *ngIf="circularProgressiveWait">
  <div class="loading-content">
    <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem" role="status"></div>
    <p class="mb-1"><strong>Carregando posições de emergência...</strong></p>
    <small class="text-muted">Esta operação pode levar alguns minutos.</small>
  </div>
</div>

<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-md-9">
        <h6>Posições de Emergência</h6>
      </div>
      <div class="col-md-3 text-end">
        <button
          class="btn btn-sm btn-success me-2"
          (click)="exportCsv()"
          title="Exportar CSV"
          [disabled]="items.length === 0"
        >
          <i class="mdi mdi-file-download-outline"></i> CSV
        </button>
        <button class="btn btn-sm btn-primary" (click)="loadData()">
          Atualizar
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
      <button class="btn btn-sm btn-outline-danger ms-3" (click)="loadData()">Tentar novamente</button>
    </div>

    <div class="mb-3" *ngIf="!circularProgressiveWait && items.length > 0">
      <span class="fw-semibold">Quantidade de registros:</span>
      <span class="badge bg-primary ms-2">{{ items.length }}</span>
    </div>

    <div class="table-responsive" *ngIf="!circularProgressiveWait">
      <table class="table table-bordered table-sm table-hover">
        <thead class="table-light">
          <tr>
             <th>Serial</th>
            <th>Placa</th>
            <th>Fornecedor</th>
            <th>Tipo Evento</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Ignição</th>
            <th>Velocidade</th>
            <th>Data/Hora Evento</th>
            <th>Ativo</th>
            <th>Hardware</th>
            <!--<th>Firmware</th> -->
            <th>Marca</th>
            <th>Modelo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td>{{ item.serial }}</td>
            <td>{{ item.placa ?? '-' }}</td>
            <td>{{ item.fornecedorRastreador }}</td>
            <td>{{ item.tipoEvento }}</td>
            <td>{{ item.latitude }}</td>
            <td>{{ item.longitude }}</td>
            <td>{{ item.ignicao }}</td>
            <td>{{ item.velocidade }}</td>
            <td>{{ item.datahora }}</td>
            <td>{{ item.installation?.isActive ? 'Sim' : 'Não' }}</td>
            <td>{{ item.installation?.deviceName }}</td>
            <!--<td>{{ item.versaoFirmware }}</td> -->
            <td>{{ item.installation?.brand }}</td>
            <td>{{ item.installation?.model }}</td>
          </tr>
          <tr *ngIf="items.length === 0">
            <td colspan="10" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
